import { makeStyles, Theme } from "@material-ui/core";

const customDrawerStyles = makeStyles(
  (theme: Theme) => ({
    borders: {
      borderRadius: "20px 20px 0 0",
      maxHeight: "100vh",
      overflowY: "auto",
    },
    drawerTitleClass: {
      padding: 0,
      margin: 8,
    },
  }),
  { index: 1 }
);

export default customDrawerStyles;
